const PageNotFound = () => {
  return (
    <div style={{ padding: "5rem", textAlign: "center" }}>
      <h1 style={{ fontSize: "5rem" }}>404</h1>
      <p>La página que buscas no existe.</p>
    </div>
  );
};

export default PageNotFound;
